export const convertNewLinesToParagraphs = (text: string) => {
  const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;

  if (htmlTagRegex.test(text)) {
    return text;
  } else {
    const lines = text.split('\n');

    const paragraphs = lines.map(line => `<p>${line}</p>`);

    return paragraphs.join('');
  }
};
